import React, { useState } from "react";
import "./Modal.css";
import config from "../../config";

// styles
import useStyles from "../login/styles";

//Components
import { Chip } from "@material-ui/core";

const states = {
    Activo: "success",
    Suspendido: "warning",
    Inactivo: "secondary",
};

const ModalAccess = ({ isOpen, closeModal, name, photo, status, aa, message, box, pesas, }) => {
    var classes = useStyles();
    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);

    const handleContainerClick = (e) => e.stopPropagation();

    const onSubmit = async e => {
        e.preventDefault();
        closeModal();
    }

    return <article className={status == 'Activo' ? `access ${isOpen && "is-open"}` : `access-denied ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-access" onClick={handleContainerClick}>

            <div style={{ textAlign: "center" }}>
                {photo != '' && photo != 'emptyPhoto' && photo != null ? (
                    <img
                        src={baseUrl + "userImage/" + photo}
                        alt=""
                        height={350}
                        height={350}
                    />
                ) : (
                    <div style={{
                        height: "350px", width: "350px", backgroundColor: "#e0e0e0", margin: "auto"
                    }}>
                    </div>
                )}

                <p style={{ color: "#FFFFFF", fontSize: "36px" }}>{name}</p>
                <div style={{ textAlign: "center" }}>
                    <Chip label={status} classes={{ root: classes[states[status]] }} />
                </div>

                <div style={{ textAlign: "center", marginTop: "12px" }}>
                    <text style={{ color: "#FFFFFF", fontSize: "16px" }}>{"Box: " + box}</text>
                </div>
                <text style={{ color: "#FFFFFF", fontSize: "16px" }}>{"Pesas: " + pesas}</text>

                <p style={{ color: "#FFFFFF", fontSize: "28px" }}>{message}</p>
                <p style={{ color: "#FFFFFF", fontSize: "26px" }}>{aa}</p>
                <br />
                <button
                    className={classes.enableButton}
                    onClick={onSubmit}
                >Cerrar</button>
            </div>

        </div>
    </article>
}

export default ModalAccess;